import React from "react";
import IntlMessages from "@util/IntlMessages";
import AdvertisementListSettings from "./AdvertisementListSettings";
import AdvertisementListPrivateChatSettings from "../ListSettings/AdvertisementListPrivateChatSettings";
import AdvertisementListPublicChatSettings from "../ListSettings/AdvertisementListPublicChatSettings";
import AdvertisementListDataSettings from "./AdvertisementListDataSettings";
import GlobalSettings from "../GlobalSettings/GlobalSettingsModal";
import { Tabs } from "../../../BP2Components";
import TabPane from "../../../BP2Components/Tabs/TabPane";

const AdvertisementListModal = (props) => {
   return (
      <Tabs defaultActiveKey="1">
         <TabPane tab={<IntlMessages id="settings.globalSettings" />} key="1">
            <GlobalSettings {...props} />
         </TabPane>
         <TabPane tab={<IntlMessages id="settings.viewSettings" />} key="2">
            <AdvertisementListSettings {...props} />
         </TabPane>
         <TabPane tab={<IntlMessages id="settings.dataSettings" />} key="3">
            <AdvertisementListDataSettings {...props} />
         </TabPane>
         <TabPane tab={<IntlMessages id="settings.private.chat.settings" />} key="4">
            <AdvertisementListPrivateChatSettings {...props} />
         </TabPane>
         <TabPane tab={<IntlMessages id="settings.public.chat.settings" />} key="5">
            <AdvertisementListPublicChatSettings {...props} />
         </TabPane>
      </Tabs>
   );
};

export default AdvertisementListModal;
